import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface OrdersState {
    orderId?: string;
}

const initialState = {
    orderId: undefined,
} satisfies OrdersState as OrdersState;

const ordersSlice = createSlice({
    initialState,
    name: 'orders',
    reducers: {
        orderIdReceived(state, action: PayloadAction<{ orderId: string }>) {
            state.orderId = action.payload.orderId;
        },
    },
    selectors: {
        selectOrderId: (state: OrdersState) => state.orderId,
    },
});

export const { orderIdReceived } = ordersSlice.actions;
export const { selectOrderId } = ordersSlice.selectors;
export const getOrdersSelectors = ordersSlice.getSelectors;
export const ordersReducer = ordersSlice.reducer;
